import List from "@/components/list";
import Bus from "./Bus.js";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const audit = listeners["audit"] || function() {};
  const downloadFile = listeners["download-file"] || function() {};


  function handleView({ row }) {
    if (row.auditStatus === 0) {
      // Bus.$emit("update", row, 0);
      audit(row)
    } else {
      // Bus.$emit("details", row);
      audit(row)
    }
  }

  //附件下载
  function handleDownloadFile(enroll) {
    if (enroll.attachment) {
      downloadFile(enroll)
      // Bus.$emit("downloadEnrollAuditFile", enroll);
    }
  }
  // 显示附件
  const ShowFileName = ({ props: { vo } }) => {
    if (vo.row.attachment) {
      return (
        <el-button
          class="no-padding"
          size="small"
          type="text"
          // v-permission="work:download"
          onClick={() => handleDownloadFile(vo.row)}
        >
          {vo.row.attachmentName}
        </el-button>
      )
    } else {
      return (
        <span>{vo.row.attachmentName}</span>
      )
    }
  };
  const Deal = ({ props: { vo } }) => {
    let flag = vo.row.auditStatus === 0;
    let icon = flag ? "icon-audit" : "icon-steps";
    let explain = flag ? "审核" : "查看审核详情";
    let per = flag ? "audit:enroll:updateBatch" : "audit:enroll:list";
    const dealConf = [[icon, explain, () => handleView(vo), per]];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  function selectable(row, index) {
    return row.auditStatus === 0;
  }
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      selectable: selectable
    },
    // {
    //   label: "班级名称",
    //   prop: "className",
    //   minWidth: "150"
    // },
    {
      label: "学员姓名",
      prop: "userName",
      width: "90"
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "150"
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "200"
    },
    {
      label: "浙政钉绑定状态",
      prop: "zzdBindStatusStr",
      minWidth: "90"
    },
    {
      label: "报名附件",
      minWidth: "80",
      showOverflowTooltip: true,
      render: vo => <ShowFileName vo={vo} />
    },
    {
      label: "审核状态",
      prop: "auditStatusName",
      minWidth: "90"
    },
    {
      label: "报名时间",
      prop: "registrationTime",
      minWidth: "120"
    },
    {
      label: "操作",
      width: "80",
      fixed: "right",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List 
      {...args} 
      talbeCols={AccountTableConfig}
      onSelectionChange={RCSelectionChange} 
      />
    </div>
  );
};
export default Table;
